interface ListItem {
  startYear: number | null;
  startMonth: number | null;
  endMonth: number | null;
  endYear: number | null;
}
const getCurrentYearAndMonth = () => {
  const now = new Date();
  return {currentYear: now.getFullYear(), currentMonth: now.getMonth() + 1};
};

export const sortByYearMonthDesc = <T extends ListItem>(list: T[]) => {
  const {currentYear, currentMonth} = getCurrentYearAndMonth();
  const result = list.slice();
  const listWithDates = result.filter((entry) => !!entry.startYear && !!entry.startMonth) as any[];
  const listWithoutDates = result.filter((entry) => !entry.startYear || !entry.startMonth);
  const sortedResult = listWithDates.sort((a, b) => {
    const aEndYear = a.endYear ?? currentYear;
    const aEndMonth = a.endMonth ?? currentMonth;
    const bEndYear = b.endYear ?? currentYear;
    const bEndMonth = b.endMonth ?? currentMonth;

    if (aEndYear !== bEndYear) {
      return bEndYear - aEndYear;
    }

    if (aEndMonth !== bEndMonth) {
      return bEndMonth - aEndMonth;
    }

    if (a.startYear !== b.startYear) {
      return b.startYear - a.startYear;
    }

    return b.startMonth - a.startMonth;
  });

  return [...sortedResult, ...listWithoutDates];
};

interface YearlyListItem {
  startYear: number;
  endYear: number | null;
}

export const sortByYearDesc = <T extends YearlyListItem>(list: T[]) => {
  const currentYear = getCurrentYearAndMonth().currentYear;
  const result = list.slice();
  return result.sort((a, b) => {
    const aEndYear = a.endYear ?? currentYear;
    const bEndYear = b.endYear ?? currentYear;

    if (aEndYear !== bEndYear) {
      return bEndYear - aEndYear;
    }

    const aStartYear = a.startYear ?? 0;
    const bStartYear = b.startYear ?? 0;

    return bStartYear - aStartYear;
  });
};
